module.exports = __webpack_public_path__ + "static/media/Adobe_Corporate_Horizontal_Lockup_White_RGB.bc2c4e8c.svg";